import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FleetChecklist } from 'src/app/validation/models/fleet-checklist';

import { FleetChecklistListStoreService } from '../../store/fleet-checklist-list-store.service';
import { FleetChecklistEditorService } from '../../services/fleet-checklist-editor.service';
import { FleetChecklistBulkEditorService } from '../../services/fleet-checklist-bulk-editor.service';

@Component({
  selector: 'app-fleet-checklist-list-view',
  templateUrl: './fleet-checklist-list-view.component.html',
  styleUrls: ['./fleet-checklist-list-view.component.scss','../../styles/styles-component.scss']
})
export class FleetChecklistListViewComponent implements OnInit {
  searchTerm: string = '';
  options : any[] = []
  constructor(
    public store: FleetChecklistListStoreService,
    public fleetEditor : FleetChecklistEditorService,
    private titleService: Title,
    public builkEditor : FleetChecklistBulkEditorService
  ) { }

  ngOnInit(): void {
    this.store.fetchFleets();
    this.options = [
      { label: 'Subir Programación', icon: 'pi pi-upload', command: () => {this.builkEditor.openUploadImageModal()} },
    ];
    this.titleService.setTitle('Validaciones - GL Tracker');

  }

  onCreated(summary: FleetChecklist): void {
    this.store.fetchFleets();
  }
  onUpdated(summary: FleetChecklist): void {
    this.store.fetchFleets();
  }
  onUploaded(fleets: FleetChecklist[]): void {
    console.log('onUploaded fleets',fleets)
    this.store.addFleetChecklists(fleets);
    // this.store.fetchFleets();
  }


  clickCreateFleet(): void {
    this.fleetEditor.openToCreate();
  }

  onSearchChange(): void {
    this.store.setSearchTerm(this.searchTerm);
  }
}
